import React, { Fragment, useState } from 'react';
import {
  Switch,
  Route,
  Link,
  NavLink
} from 'react-router-dom';
import './style.css';

import Carousel, { Modal, ModalGateway } from 'react-images';

import portraitBW from './views/home/nater5bw.png';

const images = [{ src: 'assets/1.png', alt: 'mood board' }, { src: 'assets/2.png', alt: 'design' }, { src: 'assets/3.png', alt: 'design' }, { src: 'assets/4.png', alt: 'design' }, { src: 'assets/5.png', alt: 'design' }, { src: 'assets/6.png', alt: 'design' }, { src: 'assets/7.png', alt: 'design' }, { src: 'assets/8.png', alt: 'design' }];

export default function App() {
  return (
    <div className='main'>
      <Header />
      <Switch>
        <Route exact path='/'>
          <Home />
        </Route>
        <Route path='/portfolio'>
          <Gallery />
        </Route>
        <Route path='/contact'>
          <Contact />
        </Route>
      </Switch>
    </div>
  );
}

function Header() {
  return (
    <Fragment>
      <article className='left-side-text'>
        <Link to='/'>nate voisan</Link>
      </article>
      <article className='right-side-text'>
        los angeles
      </article>
      <article className='top-side-text'>
        <ul>
          <NavLink exact to='/' activeClassName='active-link'><li>home</li></NavLink>
          <NavLink to='/contact' activeClassName='active-link'><li>contact</li></NavLink>
          <NavLink to='/portfolio' activeClassName='active-link'><li>portfolio</li></NavLink>
        </ul>
      </article>
      <article className='bottom-side-text'>
        <a className='site-design' href='http://rvoisan.com'>site design</a>
      </article>
    </Fragment>
  );
}

function Home() {
  return (
    <article className='hero-portrait'>
      <div className='background-text'>
        <h1>fashion</h1>
      </div>
      <div className='portrait'>
        <img className='portrait-bw' src={portraitBW} alt='nate voisan'/>
      </div>
      <div className='foreground-text'><h2>
        <span className='design'>design</span>
        <span className='and'>&</span>
        <span className='merchandising'>merchandising</span></h2>
      </div>
    </article>
  );
}

function Gallery() {
  const [modalIsOpen, setModal] = useState(false);
  const [currentView, setCurrentView] = useState(5);

  function toggleModal(view) {
    setModal(!modalIsOpen);
    setCurrentView(view);
  }

  return (
    <Fragment>
      <ul className='gallery' style={{visibility: modalIsOpen && 'hidden'}}>
        {images.map((image, index) => (<li className='thumbnail' key={index} onClick={() => toggleModal(index)}><img src={image.src} alt={image.alt} /></li>))}
      </ul>
      <ModalGateway>
        {modalIsOpen ? (
          <Modal onClose={toggleModal}>
            <Carousel currentIndex={currentView} views={images} />
          </Modal>
        ) : null}
      </ModalGateway>
    </Fragment>
  );
}

function Contact() {
  return (
    <section className='contact'>
      <h2 className='email-address'>nate.voisan@gmail.com</h2>
      <h2 className='email-address-reflection'>nate.voisan@gmail.com</h2>
    </section>
  );
}
